<template>
  <div class="loader">
    <img alt="Loading icon" src="/assets/images/wila-loader.svg" />
  </div>
</template>

<script>
export default {
  name: 'Loader'
};
</script>

<style lang="scss" scoped>
.loader {
  display: flex;
  justify-content: center;
}

img {
  height: 60px;
  width: 60px;
}
</style>
